import PropTypes from 'prop-types';
// @mui
import { Grid } from '@mui/material';
import SubscriptionCard from './SubscriptionCard';

// ----------------------------------------------------------------------

SubscriptionList.propTypes = {
  subscriptions: PropTypes.array.isRequired,
};

export default function SubscriptionList({ subscriptions, ...other }) {
  return (
    <Grid container spacing={3} {...other}>
      {subscriptions.map((subscription) => (
        <Grid key={subscription.id} item xs={12} sm={6} md={3}>
          <SubscriptionCard subscription={subscription} />
        </Grid>
      ))}
    </Grid>
  );
}
